import React from 'react';

import AdminAccess from '../containers/AdminAccess';

const AdminAccessAppClient = (props) => (
  <AdminAccess {...props} />
);

export default AdminAccessAppClient
